/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import { Button, Dropdown, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getSearchModulesObjects, SelectMainNavigation } from "../../redux/actions/adminActions";
import { useLocation } from "react-router-dom";
import { NavigationsLinks } from "../../AppModules";
import { hasD2cOpsAccess } from "../Franchise/D2CDashboard/d2cAccess";
import SearchIcon from "../../assets/img/search_icons.svg";
import MainMenuIcon1 from "../../assets/img/Inventory.svg";
import MainMenuIcon2 from "../../assets/img/admin-tools.svg";
import MainMenuIcon3 from "../../assets/img/order-management.svg";
import MainMenuIcon4 from "../../assets/img/crm-tools.svg";
import MainMenuIcon5 from "../../assets/img/dashboard_icon.svg";
import { apiMapping } from "../../APIpermission";
import { hasWarrantyPermission } from "../Warranty/common/warrantyAccess";
import { confirmLeave } from "../Warranty/common/unsavedGuard";

const CommonSearchNavigationsButton = (props) => {
    const { setLogoutModal } = props;
    const [ search, setSearch ] = useState("");
    const [ showMore, setShowMore ] = useState(8);
    const [ dropdownOpen, setDropdownOpen ] = useState(false);
    const { SearchModulesObj, selfInfo } = useSelector((state) => state.adminReducers);
    const Navigate = useNavigate();
    const Dispatch = useDispatch();
    const Location = useLocation();
    const inputRef = useRef(null);

    // search bar field
    const onChangeSearch = (e) => {
        setSearch(e.target.value);
        Dispatch(getSearchModulesObjects(e.target.value));
        setDropdownOpen(e.target.value !== "");
    };

    // select navigations
    const SelectNavigations = (data) => {
        if(data?.module_name === "Logout") {
            setLogoutModal(true);
        } else if(!confirmLeave()) {
            // the Warranty draft editor holds changes that are not saved yet
            return;
        } else {
            Navigate(data?.navigate_url);
            Dispatch(getSearchModulesObjects(data?.module_name));
            setSearch("");
            setDropdownOpen(false);
    
            if(data?.parent_module_name === "Product Masters" || data?.parent_module_name === "Stores" || data?.parent_module_name === "Warehouse") {
                Dispatch(SelectMainNavigation("Inventory"));
            } else if(data?.parent_module_name === "Admin Tools" || data?.parent_module_name === "Masters") {
                Dispatch(SelectMainNavigation("Admin-Tools"));
            } else if(data?.parent_module_name === "Order Management" || data?.parent_module_name === "AFS Order Management" || data?.parent_module_name === "Payment Manager") {
                Dispatch(SelectMainNavigation("Franchise"));
            } else if(data?.parent_module_name === "CRM" || data?.parent_module_name === "Re-Sale" || data?.parent_module_name === "Dealer App") {
                Dispatch(SelectMainNavigation("CRM-Tools"));
            } else if(data?.parent_module_name === "Dashboard") {
                Dispatch(SelectMainNavigation("Dashboard"));
            } else if(data?.parent_module_name === "Warranty") {
                Dispatch(SelectMainNavigation("Warranty"));
            };
        }
    };

    useEffect(() => {
        setSearch("");
        setDropdownOpen(false);
    }, [ Location ]);
    
    const NavigationsLinksWithPermissions = NavigationsLinks?.filter((elm) => {
        if(selfInfo?.user?.user_type !== "super_admin") {
            const CurrentPermissions = Object.assign({}, selfInfo?.user?.permissions_access);

            // D2C Dashboard is listed under Order Management but its permission
            // lives in the D2C group, so check that instead.
            if (elm?.module_name === "D2C Dashboard") {
                return hasD2cOpsAccess(selfInfo);
            }

            if (elm?.parent_module_name === "Dashboard") {
                const UpdateDashBoard = CurrentPermissions?.DashboardMain?.map((elmz) => {
                    if(elmz?.label === "Dashboard Sales Revenue Report") {
                        return {
                            ...elmz,
                            label: "Sales Revenue Report",
                        }
                    } else if(elmz?.label === "Dashboard Ageing Outstanding") {
                        return {
                            ...elmz,
                            label: "Ageing Outstanding",
                        }
                    } else {
                        return elmz;
                    } 
                });
                const matchingModules = UpdateDashBoard?.filter(modulesz => 
                    modulesz?.label?.toLowerCase() === elm?.module_name?.toLowerCase()
                );
                if(matchingModules !== undefined) {
                    return matchingModules[0]?.View === true;
                };
            } else if (elm?.parent_module_name === "Product Masters") {
                const matchingModules = CurrentPermissions?.ProductMasters?.filter(modulesz => 
                    modulesz?.label?.toLowerCase() === elm?.module_name?.toLowerCase()
                );
                return matchingModules?.[0]?.View === true;
            } else if (elm?.parent_module_name === "Stores") {
                const matchingModules = CurrentPermissions?.Store?.filter(modulesz => 
                    modulesz?.label?.toLowerCase() === elm?.module_name?.toLowerCase()
                );
                return matchingModules?.[0]?.View === true;
            } else if (elm?.parent_module_name === "Warehouse") {
                const matchingModules = CurrentPermissions?.Warehouse?.filter(modulesz => 
                    modulesz?.label?.toLowerCase() === elm?.module_name?.toLowerCase()
                );
                return matchingModules?.[0]?.View === true;
            } else if (elm?.parent_module_name === "Admin Tools") {
                const matchingModules = CurrentPermissions?.AdminTools?.filter(modulesz => 
                    modulesz?.label?.toLowerCase() === elm?.module_name?.toLowerCase()
                );
                return matchingModules?.[0]?.View === true;
            } else if (elm?.parent_module_name === "Masters") {
                const matchingModules = CurrentPermissions?.Masters?.filter(modulesz => 
                    modulesz?.label?.toLowerCase() === elm?.module_name?.toLowerCase()
                );
                return matchingModules?.[0]?.View === true;
            } else if (elm?.parent_module_name === "CRM") {
                const matchingModules = CurrentPermissions?.CRMTools?.filter(modulesz => 
                    modulesz?.label?.toLowerCase() === elm?.module_name?.toLowerCase()
                );
                return matchingModules?.[0]?.View === true;
            } else if (elm?.parent_module_name === "Re-Sale") {
                const matchingModules = CurrentPermissions?.ReSells?.filter(modulesz => 
                    modulesz?.label?.toLowerCase() === elm?.module_name?.toLowerCase()
                );
                return matchingModules?.[0]?.View === true;
            } else if (elm?.parent_module_name === "Order Management") {
                const matchingModules = CurrentPermissions?.OrderManagement?.filter(modulesz => 
                    modulesz?.label?.toLowerCase() === elm?.module_name?.toLowerCase()
                );
                return matchingModules?.[0]?.View === true;
            } else if (elm?.parent_module_name === "AFS Order Management") {
                const matchingModules = CurrentPermissions?.AFSOrderManagement?.filter(modulesz => 
                    modulesz?.label?.toLowerCase() === elm?.module_name?.toLowerCase()
                );
                if(matchingModules !== undefined) {
                    return matchingModules[0]?.View === true;
                };
            } else if (elm?.parent_module_name === "Payment Manager") {
                const matchingModules = CurrentPermissions?.PaymentManager?.filter(modulesz => 
                    modulesz?.label?.toLowerCase() === elm?.module_name?.toLowerCase()
                );
                return matchingModules?.[0]?.View === true;
            } else if (elm?.parent_module_name === "Dealer App") {
                if(CurrentPermissions?.DealerApp) {
                    const matchingModules = CurrentPermissions?.DealerApp?.filter(modulesz => 
                        modulesz?.label?.toLowerCase() === elm?.module_name?.toLowerCase()
                    );
                    return matchingModules[0]?.View === true;
                };
            } else if (elm?.parent_module_name === "Warranty") {
                // Warranty entries are named like their permission label in APIpermission.js
                return hasWarrantyPermission(selfInfo, apiMapping[elm?.module_name]?.Edit);
            };
    
            return false;
        }
    });

    // get parent module  icon
    const getParentModuleIcon = (parentModuleName) => {
        if(parentModuleName === "Dashboard") {
            return(<div className="searchNavigationIcons">
                <Image src={MainMenuIcon5} className="dishboard_icons" alt="menu_icon" />
            </div>)
        } else if(parentModuleName === "Product Masters" || parentModuleName === "Stores" || parentModuleName === "Warehouse") {
            return(<div className="searchNavigationIcons">
                <Image src={MainMenuIcon1} alt="menu_icon" />
            </div>)
        } else if(parentModuleName === "Admin Tools" || parentModuleName === "Masters") {
            return(<div className="searchNavigationIcons">
                <Image src={MainMenuIcon2} alt="menu_icon" />
            </div>)
        } else if(parentModuleName === "Order Management" || parentModuleName === "AFS Order Management" || parentModuleName === "Payment Manager") {
            return(<div className="searchNavigationIcons">
                <Image src={MainMenuIcon3} alt="menu_icon" />
            </div>)
        } else if(parentModuleName === "CRM" || parentModuleName === "Re-Sale" || parentModuleName === "Dealer App") {
            return(<div className="searchNavigationIcons">
                <Image src={MainMenuIcon4} alt="menu_icon" />
            </div>)
        } else if(parentModuleName === "Warranty") {
            return(<div className="searchNavigationIcons">
                <i className="bi bi-shield-check"></i>
            </div>)
        } else if(parentModuleName === "Logout") {
            return(<div className="searchNavigationIcons logout_design">
                <i className="bi bi-exclamation-triangle-fill"></i>
            </div>)
        };
    };

    // navigations modules filter array
    const AllPermissions = selfInfo?.user?.user_type === "super_admin" ? NavigationsLinks : NavigationsLinksWithPermissions;
    const NavigationsFilter = AllPermissions?.filter((elms) => {
        if(search !== "") {
            if (
                elms?.module_name?.toLowerCase().includes(
                    search && search.toLowerCase(),
                )
            ) {
                return elms;
            };
        } else {
            return elms;
        };
    });

    // clear search
    const ClearSearch = () => {
        Dispatch(getSearchModulesObjects(""));
        setSearch("");
        setDropdownOpen(false);
    };

    // view more function
    const ViewMoreFunction = () => {
        if(showMore === 8) {
            setShowMore(NavigationsFilter?.length)
        } else {
            setShowMore(8)
        };
    };

    // Function to handle keypress
    const handleKeyPress = (e) => {
        if (e.ctrlKey && e.key === 'p') {
            e.preventDefault(); // Prevent default browser action (if needed)
            inputRef.current.focus(); // Focus on the input box
            inputRef.current.select(); // Focus on the input box
            setDropdownOpen(true);
        };
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyPress);

        // Cleanup the event listener when the component is unmounted
        return () => {
        window.removeEventListener('keydown', handleKeyPress);
        };
    }, []);

    return(<div className="search_Navigations_wrapper">
        <Dropdown 
            // show={dropdownOpen && search} 
            show={dropdownOpen} 
            onToggle={(isOpen, event, metadata) => {
                setDropdownOpen(isOpen);
            }}
        >
            <Dropdown.Toggle id="dropdown-basic">
                <Image src={SearchIcon} className="search_icons" alt="search" />
                <input 
                    type="text" 
                    ref={inputRef}
                    className="form-control"
                    value={search || SearchModulesObj}
                    onChange={(e) => onChangeSearch(e)}
                    placeholder="Search or type a command (Ctrl + P)"
                />
                {(search !== "" || SearchModulesObj !== "") && (<i className="bi bi-x-circle-fill" onClick={() => ClearSearch()}></i>)}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item className="searchHeading_links" disabled>
                    <Image src={SearchIcon} className="search_icons" alt="search" /> Search<strong>{search || SearchModulesObj}</strong>
                </Dropdown.Item>
                {NavigationsFilter && NavigationsFilter?.length > 0 ? NavigationsFilter?.slice(0, showMore)?.map((elm, index) => {
                    const escapeRegExp = (string) => {
                        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special characters
                    };
                    
                    const highlightSearchTerm = (text, searchTerm) => {
                        if (!searchTerm) return text;
                        const escapedSearchTerm = escapeRegExp(searchTerm); // Escape special characters
                        const parts = text.split(new RegExp(`(${escapedSearchTerm})`, 'gi')); // Use escaped term
                        return parts.map((part, i) =>
                            part.toLowerCase() === searchTerm.toLowerCase() ? (
                                <strong key={i}>{part}</strong>
                            ) : (
                                part
                            )
                        );
                    };

                    return(<Dropdown.Item key={index} onClick={() => SelectNavigations(elm)}>
                            {getParentModuleIcon(elm?.parent_module_name)}
                            <div className="modules_names">
                                {highlightSearchTerm(elm?.module_name, search)}
                                <small>{elm?.parent_module_name}</small>
                            </div>
                        </Dropdown.Item>)
                    }) : (<Dropdown.Item className="module_not_found" disabled>
                        <i className="bi bi-ban"></i> Module not found
                    </Dropdown.Item>)}
                {NavigationsFilter?.length > 8 && (<Button id="viewmore_btn" onClick={() => ViewMoreFunction()}>{showMore === 8 ? "View More" : "View Less"}</Button>)}
            </Dropdown.Menu>
        </Dropdown>
    </div>)
}

export default CommonSearchNavigationsButton;